// extracted by mini-css-extract-plugin
export default {"wayButton":"styles_wayButton__sAsVb","active":"styles_active__TH9Mr"};